import {User} from "./User";
import {UserCounty} from "./UserCounty";
import {WpProvider} from "./wp-provider.model";




export class ProviderOffice {
  constructor(

    public id?: number,
    public serviceCounty?: number,
    public officeName?: any,
    public primaryContactFirstName?: any,
    public primaryContactLastName?: any,
    public primaryAddrLine1?: any,
    public primaryAddrLine2?: any,
    public primaryCity?: any,
    public primaryState?: any,
    public primaryZip5?: any,
    public primaryZip4?: any,
    public primaryPhoneNumber?: any,
    public primaryPhoneNumberExt?: any,
    public primaryFaxNumber?: any,
    public primaryEmail?: any,
    public officeBeginDt?: any,
    public officeEndDt?: any,
    public provider?: WpProvider,
    public recordVersion?: number,
  ){}
}



// WEBPACK FOOTER //
// ./src/app/shared/model/ProviderOffice.ts